import * as React from "react";
import { useCallback, useState } from "react";
import { Link, LinkContainer, IfPermitted } from "components/common";
import ShareButton from "components/common/ShareButton";
import Icon from "components/common/Icon";
import { ButtonToolbar, Button, DropdownButton, DeleteMenuItem } from "components/bootstrap";
import UserFilterShareModal from "search-filter/components/UserFilterShareModal";
import useSearchFilterUsagesSummaryQuery from "search-filter/hooks/useSearchFilterUsagesSummaryQuery";
import useUserSearchFilterMutation from "search-filter/hooks/useUserSearchFilterMutation";
import confirmActionUsagesAlert from "search-filter/confirmActionUsagesAlert";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import usePluggableEntitySharedActions from "hooks/usePluggableEntitySharedActions";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import SearchFiltersRoutes from "search-filter/Routes";
const Title = ({ filter }) => /* @__PURE__ */ React.createElement(Link, { to: SearchFiltersRoutes.SHOW(filter.id) }, filter.title || "No Title");
const FiltersOverviewItem = ({ filter }) => {
  const [showFilterShareModal, setShowFilterShareModal] = useState(false);
  const { isFetching: isFetchingUsagesSummary, refetch } = useSearchFilterUsagesSummaryQuery(filter.id, {
    enabled: false
  });
  const { delete: deleteFilter } = useUserSearchFilterMutation();
  const sendTelemetry = useSendTelemetry();
  const { actions: pluggableActions, actionModals: pluggableActionModals } = usePluggableEntitySharedActions(filter, "search_filter");
  const { getPluggableTableCells } = usePluggableEntityTableElements(
    null,
    "search_filter"
  );
  const currentUser = useCurrentUser();
  const toggleShareModalOpen = useCallback(() => {
    setShowFilterShareModal((cur) => !cur);
  }, [setShowFilterShareModal]);
  const onDeleteMyFilter = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_FILTER_DELETED, {
      app_pathname: "my-filters",
      app_section: "search-filter"
    });
    if (!isFetchingUsagesSummary) {
      refetch().then(({ data: { summary: usagesSummary } }) => {
        var _a;
        if ((usagesSummary == null ? void 0 : usagesSummary.length) && !confirmActionUsagesAlert({
          action: "Deleting",
          usagesSummary,
          additionalExplanation: "\nThe filter will be removed from entities where you are the owner and transformed to an inline filter where you are not an owner"
        })) {
          return Promise.resolve();
        }
        return (_a = deleteFilter(filter.id)) == null ? void 0 : _a.then((res) => res);
      });
    }
  }, [isFetchingUsagesSummary, refetch, deleteFilter, filter.id, sendTelemetry]);
  const moreActions = [
    pluggableActions.length ? pluggableActions : null,
    isPermitted(currentUser.permissions, `search_filters:delete:${filter.id}`) ? /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: onDeleteMyFilter, key: "delete-menu-item" }) : null
  ].filter(Boolean);
  return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Title, { filter })), /* @__PURE__ */ React.createElement("td", null, filter.queryString), /* @__PURE__ */ React.createElement("td", null, filter.description || /* @__PURE__ */ React.createElement("i", null, "No description given.")), /* @__PURE__ */ React.createElement("td", null, getPluggableTableCells(filter.id)), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(ButtonToolbar, { className: "pull-right" }, /* @__PURE__ */ React.createElement(ShareButton, { entityType: "search_filter", entityId: filter.id, onClick: toggleShareModalOpen, bsSize: "xs" }), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `search_filters:edit:${filter.id}` }, /* @__PURE__ */ React.createElement(LinkContainer, { to: SearchFiltersRoutes.EDIT(filter.id) }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs" }, /* @__PURE__ */ React.createElement(Icon, { name: "edit_square" }), " Edit"))), !!moreActions.length && /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      key: "more-actions-button",
      title: "More actions",
      bsSize: "xs",
      pullRight: true,
      id: `more-actions-dropdown-${filter.id}`
    },
    moreActions
  )), showFilterShareModal && /* @__PURE__ */ React.createElement(UserFilterShareModal, { filter, toggleShareModalOpen }), pluggableActionModals));
};
export default FiltersOverviewItem;
